export default "__VITE_ASSET__CeLBei2x__"